const state = {
  dragging: false,
  dragList: [],
  dragParentId: '',
  checkedIds: [],
  checkedNodes: [],
  selectedId: '',
  formType: '',
  formNodeId: '',
  formVisble: false,
  formCallback: null,
  dragState: {}
};
// 同步
const mutations = {
  SET_DRAG_LIST: (state, list) => {
    state.dragging = true;
    state.dragList = list;
  },
  DRAGGING_END: state => {
    state.dragging = false;
    state.dragIndex = -1;
  },
  SET_DRAG_PARENT_ID: (state, nodeId) => {
    state.dragParentId = nodeId;
  },
  ADD_CHECKED_ID: (state, nodeId) => {
    if (!state.checkedId.includes(nodeId)) {
      state.checkedId.push(nodeId);
    }
  },
  REMOVE_CHECKED: (state, nodeId) => {
    let index = state.checkedId.findIndex(i => i === nodeId);
    if (index > -1) {
      state.checkedId.splice(index, 1);
    }
  },
  // ADD_CHECKED_NODE: (state, node) => {
  //   let index = state.checkedNodes.findIndex(
  //     item => item.nodeId === node.nodeId
  //   );
  //   if (index > -1) return;
  //   state.checkedNodes.push(node);
  // },
  // REMOVE_CHECKED_NODE: (state, nodeId) => {
  //   let index = state.checkedNodes.findIndex(item => item.nodeId === nodeId);
  //   if (index > -1) {
  //     state.checkedNodes.splice(index, 1);
  //   }
  // },
  SELECTED: (state, v) => {
    state.selectedId = v;
  },
  INIT_TREE_ID: (state, data) => {
    Object.keys(data).forEach(key => {
      state[key] = data[key];
    });
  },
  INIT_TREE: (state, v) => {
    Object.keys(v).forEach(key => {
      state[key] = v[key];
    });
  },
  SET_CHECKED_IDS: (state, v) => {
    state.checkedIds = v || [];
  },
  SET_FORM_TYPE: (state, v) => {
    state.formType = v;
  },
  SET_FORM_NODE_ID: (state, v) => {
    state.formNodeId = v;
  },
  SET_FORM_VISIBLE: (state, v) => {
    state.formVisble = v;
  },
  SET_FORM_CALLBACK: (state, v) => {
    state.formCallback = v;
  },
  SET_DRAR_START: (state, v) => {
    state.dragState = v;
  }
};

// 异步
const actions = {
  setDragList: ({ commit }, list) => {
    commit('SET_DRAG_LIST', list);
  },
  draggingEnd: ({ commit }) => {
    commit('SET_DRAG_LIST', []);
    commit('SET_DRAG_PARENT_ID', '');
    commit('DRAGGING_END');
  },
  setDragParentId: ({ commit }, nodeId) => {
    commit('SET_DRAG_PARENT_ID', nodeId);
  },
  addChecked: ({ commit }, list) => {
    list &&
      list.length &&
      list.forEach(item => {
        commit('ADD_CHECKED_ID', item.nodeId);
        commit('ADD_CHECKED_NODE', item);
      });
  },
  removeChecked: ({ commit }, nodeId) => {
    commit('REMOVE_CHECKED_NODE', nodeId);
    commit('REMOVE_CHECKED', nodeId);
  },
  initCategoryTree: ({ commit }, data) => {
    commit('INIT_TREE', data);
  },
  setSelectedId: ({ commit }, id) => {
    commit('SELECTED', id);
  },
  setCheckedIds: ({ commit }, data) => {
    commit('SET_CHECKED_IDS', data);
  },
  showForm: ({ commit }, { type, nodeId, callback }) => {
    commit('SET_FORM_TYPE', type);
    commit('SET_FORM_NODE_ID', nodeId);
    commit('SET_FORM_CALLBACK', callback);
    commit('SET_FORM_VISIBLE', true);
  },
  closeForm: ({ commit }) => {
    commit('SET_FORM_TYPE', '');
    commit('SET_FORM_NODE_ID', '');
    commit('SET_FORM_CALLBACK', null);
    commit('SET_FORM_VISIBLE', false);
  },
  setDragStart: ({ commit }, data) => {
    commit('SET_DRAR_START', data);
  }
};
export default {
  namespaced: true,
  state,
  actions,
  mutations
};
